import {StyleteqState} from "../_definitions/styleteq";

export const searchSelector = (state: StyleteqState) => state.search;
export const searchFiltersSelector = (state: StyleteqState) => searchSelector(state).filters
export const searchResultsSelector = (state: StyleteqState) => searchSelector(state).results


// WEBPACK FOOTER //
// ./app/client/search/selectors.ts